module.exports = __webpack_public_path__ + "static/media/global.b878a671.svg";